import React from 'react';
import { Button } from '@common-ui/ui';
import { AddCircle } from '@mui/icons-material';
import tiComponentEnum from '../../enums/tiComponentEnum';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import routerPathEnum from '../../enums/routerPathEnum';
import { useHistory } from 'react-router';
import columbiaModeEnum from '../../enums/columbiaModeEnum';
import './styles.css';

export default function Header() {
  const history = useHistory();
  const { isLoading } = useSelector((state) => state.images);
  const { mode } = useSelector((state) => state.columbia);

  return (
    mode === columbiaModeEnum.INTERACTIVE && (
      <div className="header">
        <div className="header__buttonGroup">
          <Button
            className="header__button"
            startIcon={<AddCircle />}
            onClick={() => history.push({ pathname: routerPathEnum.IMAGES })}
          >
            {tiComponentEnum.MANAGE}
          </Button>
          {isLoading ? <CircularProgress /> : <div style={{ width: '40px' }} />}
        </div>
      </div>
    )
  );
}
